import {
    LIST_NOTIFICATION_TYPES,
    LIST_NOTIFICATION_TYPES_SUCCESS,
    LIST_NOTIFICATION_TYPES_ERROR,
} from '../types';

import clienteAxios from '../config/axios';
import authToken from '../config/token';

import { ErrorMessage, SuccessMessage, WaitingMessage } from '../components/extras/toastMessages';
import { MSG_CREATE_SUCCESS, MSG_UPDATE_SUCCESS, MSG_DELETING, MSG_DELETE_SUCCESS } from '../constants/messages';
import Swal from 'sweetalert2';

const controller = 'notificacion-tipo';

//LISTAR NOTIFICATION TYPES
export function listNotificationTypesAction() {
    return async (dispatch) => {
        //Inicializo
        dispatch( listNotificationTypes() );
        //Ejecuto la consulta
        try{
            //Busco el token de cliente
            //const token = process.env.REACT_APP_CLIENT_TOKEN;
            //Lo agrego para la consulta
            //authToken(token);
            //Hago la consulta
            const response = await clienteAxios.get(`/${controller}`);
            //Obtengo los datos
            const notificationTypes = response.data;
            //Llamo al dispatch
            dispatch( listNotificationTypesSuccess(notificationTypes.content) );
        }catch(error){
            const response = error.response;
            let data = {
                data: null,
                message: 'Error al conectarse al servidor'
            };
            //Verifico si hay error
            if(response){
                data = response.data;
            }
            //Llamo al dispatch
            dispatch( listNotificationTypesError(data) );
            //Mensaje de error
            ErrorMessage(data.message);
        }
    }
}

const listNotificationTypes = () => ({
    type: LIST_NOTIFICATION_TYPES,
    payload: true
});

const listNotificationTypesSuccess = notificationTypes => ({
    type: LIST_NOTIFICATION_TYPES_SUCCESS,
    payload: notificationTypes
});

const listNotificationTypesError = error => ({
    type: LIST_NOTIFICATION_TYPES_ERROR,
    payload: error
});